import { Divider, Switch } from 'src/components/atoms';
import {
  IntakeChannelRow,
  IntakeChannelRowLabel,
  IntakeChannelRows,
  IntakeChannelsCard,
  IntakeChannelsSectionHeader,
  IntakeSectionTitle,
  SectionDescription,
  SwitchHeader,
  SwitchHelpText,
  SwitchLabel,
  SwitchSection,
} from './Configuration.styles';

export interface CoiCategoryExpandedFieldsProps {
  autoReview: boolean;
  setAutoReview: (value: boolean) => void;
  intakeChannelReportingPortal: boolean;
  setIntakeChannelReportingPortal: (value: boolean) => void;
}

export const CoiCategoryExpandedFields = ({
  autoReview,
  setAutoReview,
  intakeChannelReportingPortal,
  setIntakeChannelReportingPortal,
}: CoiCategoryExpandedFieldsProps) => (
  <>
    <Divider variant="horizontal" />
    <SwitchSection data-testid="coi-auto-review-section">
      <SwitchHeader>
        {/* VAULT-19456: Auto review is locked to enabled by default */}
        <Switch
          checked={autoReview}
          onClick={() => setAutoReview(!autoReview)}
          disabled
          data-testid="coi-auto-review-toggle"
        />
        <SwitchLabel>Auto review</SwitchLabel>
      </SwitchHeader>
      <SwitchHelpText>
        When enabled, disclosures with no flagged answers are automatically
        approved and closed. You can find these disclosures in Manage
        Disclosures &gt; Auto-Closed.
      </SwitchHelpText>
    </SwitchSection>

    <IntakeChannelsCard data-testid="coi-intake-channel-section">
      <IntakeChannelsSectionHeader>
        <IntakeSectionTitle>Intake channels</IntakeSectionTitle>
        <SectionDescription>
          This category will be available across the selected intake channels.
        </SectionDescription>
      </IntakeChannelsSectionHeader>
      <IntakeChannelRows>
        <IntakeChannelRow>
          <Switch
            checked={intakeChannelReportingPortal}
            onClick={() =>
              setIntakeChannelReportingPortal(!intakeChannelReportingPortal)
            }
            disabled
            data-testid="coi-intake-channel-reporting-portal-toggle"
          />
          <IntakeChannelRowLabel $disabled>Vault</IntakeChannelRowLabel>
        </IntakeChannelRow>
      </IntakeChannelRows>
    </IntakeChannelsCard>
  </>
);
